<template>
  <div class="flex flex-col w-full gap-4 md:gap-6">
    <header class="flex flex-col-reverse md:flex-col gap-4 md:gap-6">
      <slot name="title" :layout />
      <section
        v-if="screen.isLargeOrUnknown || $slots.toolbar"
        class="flex items-center justify-start gap-2 md:justify-end lg:justify-between"
        :class="{ 'hidden lg:flex': !$slots.toolbar }"
      >
        <SearchResultLayoutSwitch
          v-if="screen.isLargeOrUnknown"
          v-model="layout"
          class="hidden lg:inline-flex"
        />
        <slot name="toolbar" :layout />
      </section>
    </header>

    <section
      class="grid gap-6 grid-cols-1 xs:grid-cols-1 sm:grid-cols-2"
      :class="layout === 'grid' ? 'lg:grid-cols-3' : 'lg:grid-cols-1'"
      data-id="search-result-list"
    >
      <template
        v-for="(accom, index) in loading ? STUB_ITEMS : items"
        :key="accom ? getAccomKey(accom) : `accom-${index}`"
      >
        <RedesignAccomCard
          v-track:impression="{ 'search:objectImpression': [] }"
          :accom
          :trip
          :vertical="isGridView || screen.isUnknown"
          :cta="isCtaEnabled"
          :loading
          :class="{ 'grid lg:hidden': screen.isUnknown }"
        />
        <!-- is only for non-chromium browser without Client-Hints -->
        <RedesignAccomCard
          v-if="screen.isUnknown"
          v-track:impression="{ 'search:objectImpression': [] }"
          :accom
          :trip
          :vertical="false"
          :cta="isCtaEnabled"
          :loading
          :class="{ 'hidden lg:grid': screen.isUnknown }"
        />
      </template>
    </section>
  </div>
</template>

<script setup lang="ts">
import { getAccomKey } from '~/utils/accommodations'

const LAYOUT_DEFAULT = 'list'
const PAGE_SIZE = 20
const STUB_ITEMS = Array.from<undefined>({ length: PAGE_SIZE })

defineProps<{
  items?: SearchResultDocument[]
  trip?: Partial<TripParams>
  loading?: boolean
}>()

const screen = useScreen()
const isCtaMobileEnabled = useFlag('srp-accom-card-cta-btn-mobile')

const layout = ref<SearchResultLayout>(LAYOUT_DEFAULT)

const isGridView = computed(() => layout.value === 'grid' || !screen.isLarge)
const isCtaEnabled = computed(() => {
  return !isGridView.value || (screen.isExtraSmall && isCtaMobileEnabled.value)
})
</script>
